module.exports = __webpack_public_path__ + "static/img/twjd-sde7-1.79c5a6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde7-1.png
// module id = 844
// module chunks = 0